import Content from './Content';
import Date from './Date';
import Items from './Items';
import LongAnswer from './LongAnswer';
import Number from './Number';
import ShortAnswer from './ShortAnswer';
import Upload from './Upload';

export default {
    'content': Content,
    'date': Date,
    'items': Items,
    'long': LongAnswer,
    'number': Number,
    'short': ShortAnswer,
    'upload': Upload,
};
